import { render, staticRenderFns } from "./UsersUpdate.vue?vue&type=template&id=2cbac1b6"
import script from "./UsersUpdate.vue?vue&type=script&lang=js"
export * from "./UsersUpdate.vue?vue&type=script&lang=js"
import style0 from "./UsersUpdate.vue?vue&type=style&index=0&id=2cbac1b6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports